import axios, { AxiosResponse } from "axios";
import { APP_Config } from "../../helpers/AppConfig";
import { IKDBProjectInput, IDocUserQueryInput, IIngestKdbInput, IKeyInfoInput, ebook_summarization_v1 } from "../../models/APIModels";
import { configFormData, modifyFormData } from "../../helpers/ServiceHelpers";
import Service from "../../services";
import { ProjectStatus } from "../../models/ProjectModel";

class documentAIService extends Service {
  base_url = APP_Config()?.REACT_APP_DOCUMENT_AI_URL;
  socket_Url = APP_Config()?.REACT_APP_AI_SOCKET_URL;

  docai_ingest_kdb = (payload: IIngestKdbInput, type: ProjectStatus) => {
    let extended = ''
    let formData = new FormData();
    if (type === ProjectStatus.PRODUCTION) {
      extended =`/${payload?.project_name}/${payload?.version}/docai_upload_file`
      formData.append('project_id',payload.project_id);
      if (payload?.files && payload?.files?.length > 0) {
        payload?.files?.forEach((file: any) => formData.append('files', file))
      }
    } else {
      extended = '/docai_ingest_kdb'
      formData = modifyFormData(payload, formData)
    }
    return axios.post(`${this.base_url}${extended}`, formData, configFormData)
  }

  ebook_summary_ingestion = (payload: IIngestKdbInput, type: ProjectStatus) => {
    let extended = ''
    let formData = new FormData();
    if (type === ProjectStatus.PRODUCTION) {
      extended =`/${payload?.project_name}/${payload?.version}/ebook_summary_ingestion`
      formData.append('project_id',payload.project_id);
      if (payload?.files && payload?.files?.length > 0) {
        payload?.files?.forEach((file: any) => formData.append('files', file))
      }
    } else {
      extended = '/ebook_summary_ingestion'
      formData = modifyFormData(payload, formData)
    }
    return axios.post(`${this.base_url}${extended}`, formData, configFormData)
  }

  docai_kdb_summarization = (payload: IKDBProjectInput, type: ProjectStatus) => {
    let extended = ''
    let formData = new FormData();
    if (type === ProjectStatus.PRODUCTION) extended=`/${payload?.project_name}/${payload?.version}`
    formData = modifyFormData(payload, formData)
    return axios.post(`${this.base_url}${extended}/docai_kdb_summarization`, formData, configFormData)
  }

  ebook_summarization = (payload: any, type: ProjectStatus) => {
    let extended = ''
    let formData = new FormData();
    if (type === ProjectStatus.PRODUCTION) extended=`/${payload?.project_name}/${payload?.version}`
    formData = modifyFormData(payload, formData)
    return axios.post(`${this.base_url}${extended}/ebook_summarization`, formData, configFormData)
  }

  ebook_summarization_v1 = (payload: ebook_summarization_v1) => {
    // let formData = new FormData();
    // formData = modifyFormData(payload, formData)
    return axios.post(`${this.base_url}/ebook_summarization_v1`,payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
  }
  
  ebooktop_recommended_prompts = (payload:any) =>{
    let formData = new FormData();
    formData = modifyFormData(payload, formData)
    // return axios.post(`${this.base_url}/ebooktop_recommended_prompts`,formData)
    return axios.post(`${this.base_url}/ebook_recommendation`,formData)
  }

  docai_top_querys_recommender = (payload: IKDBProjectInput, type: ProjectStatus) => {
    let extended = ''
    let formData = new FormData();
    if (type === ProjectStatus.PRODUCTION) extended=`/${payload?.project_id}/${payload?.version}`
    formData = modifyFormData(payload, formData)
    return axios.post(`${this.base_url}${extended}/docai_top_querys_recommender`, formData, configFormData)
  }

  docai_get_userquery = (payload: IDocUserQueryInput, type: ProjectStatus) => {
    let extended = '/docai_get_userquery'
    let formData = new FormData();
    if (type === ProjectStatus.PRODUCTION) extended=`/${payload?.project_id}/${payload?.version}/${payload?.prompt}`
    formData = modifyFormData(payload, formData)
    return axios.post(`${this.base_url}${extended}`, formData, configFormData)
  }

  ebook_userquery = (payload: IDocUserQueryInput, type: ProjectStatus) => {
    let extended = '/ebook_userquery'
    let formData = new FormData();
    if (type === ProjectStatus.PRODUCTION) extended=`/${payload?.project_id}/${payload?.version}/${payload?.prompt}`
    formData = modifyFormData(payload, formData)
    return axios.post(`${this.base_url}${extended}`, formData, configFormData)
  }

  docai_auto_template = (payload: IIngestKdbInput): Promise<AxiosResponse<any>> => {
    let formData = new FormData();
    formData = modifyFormData(payload, formData)
    return axios.post(`${this.base_url}/docai_auto_template`, formData, configFormData)
  }

  docai_process_template = (payload: IKDBProjectInput, data: any) => {
    console.log(payload)
    const headers = {
      'project-name': payload?.project_name,
      'project-type': payload?.project_type,
      'kdb-name': payload?.unique_kdb,
      'version': payload?.version,
      'project-id': payload?.project_id,
    }
    return axios.post(`${this.base_url}/docai_process_template`, data, {
      headers: headers 
    })
  }

  docai_draft_keyinfo_ext = (payload: IKeyInfoInput, type: ProjectStatus) => {
    let extended = '/docai_draft_keyinfo_ext'
    let formData = new FormData();
    formData.append('project_id',payload.project_id);
    if (type === ProjectStatus.PRODUCTION) {
      formData.append('unique_kdb', payload?.unique_kdb || "")
      extended=`/${payload?.project_name}/${payload?.version}/docai_production_keyinfo`
      // if (payload?.files && payload?.files?.length > 0) {
      //   payload?.files?.forEach((file: any) => formData.append('files', file))
      // }
    } else {
      formData = modifyFormData(payload, formData)
    }
    return axios.post(`${this.base_url}${extended}`, formData, configFormData)
  }

  docai_doc_validation = (payload: IKDBProjectInput, type: ProjectStatus) => {
    let extended = ''
    let formData = new FormData();
    if (type === ProjectStatus.PRODUCTION) extended=`/${payload?.project_name}/${payload?.version}`
    formData = modifyFormData(payload, formData)
    return axios.post(`${this.base_url}${extended}/docai_doc_validation`, formData, configFormData)
  }

  docai_save_compliance_to_pg = (payload: IKDBProjectInput, data: any) => {
    const headers = {
      'project-name': payload?.project_name,
      'project-type': payload?.project_type,
      'kdb-name': payload?.kdbName,
      'version': payload?.version,
      'project-id': payload?.project_id,
    }
    return axios.post(`${this.base_url}/docai_save_compliance_to_pg`, data, {
      headers: headers 
    })
  }

  save_prompts = (payload: IKDBProjectInput, data: any) => {
    const headers = {
      'project-name': payload?.project_name,
      'project-type': payload?.project_type,
      'kdb-name': payload?.kdbName,
      'version': payload?.version,
      'project-id': payload?.project_id,
    }
    return axios.post(`${this.base_url}/save_prompts`, data, {
      headers: headers 
    })
  }

  api_status_list = (payload: IKDBProjectInput, type: ProjectStatus) => {
    let extended = ''
    if (type === ProjectStatus.PRODUCTION) extended=`/${payload?.project_id}/${payload?.version}`
    // const data = {
    //   'project_id': payload?.project_id,
    // }
    return axios.post(`${this.base_url}${extended}/api_status_list`,)
  }

  // This is used to clear chat history || save chat history || remove created project
  save_chat_history = (payload: any, data?: any) => {
    const headers = {
      'project-id': payload?.project_id,
      'chat-history-op':payload?.chat_history_op || ""
    }
    return axios.post(`${this.base_url}/op_chat_history`, data, {
      headers: headers,
    })
  }

  get_saved_project_info = (payload: IKDBProjectInput) => {
    return axios.post(`${this.base_url}/get_saved_project_info`,{
        project_id: payload.project_id
    } )
  }


  research_saved_project_info = (payload: IKDBProjectInput) => {
  return axios.post(`${this.base_url}/research_saved_project_info`,{
      project_id: payload.project_id
    } )
  }

   get_byfiles = (payload: any) => {
    let formData = new FormData();
    formData = modifyFormData(payload, formData)
    const headers={
      'content-type': 'multipart/form-data',
      'user-id':payload.user_id
    }
    
    return axios.post(`${this.base_url}/get_byfiles/${payload?.project_id}`)
  }

  change_project_status = (payload:any) =>{
    // project_id
    // project_status
    let formData = new FormData();
    formData = modifyFormData(payload, formData)
    return axios.post(`${this.base_url}/change_project_status`, formData, configFormData)
  }

  // connectSocket = () =>{
  //   return 
  // }

}

export default documentAIService;
